const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9P(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "105.936 -26.731 158.904 240.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      strokeWidth: 29.479,
      paintOrder: "markers"
    },
    id: "rect3812",
    width: 158.75,
    height: 240.579,
    x: 106.09,
    y: -26.731
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "rgb(255, 255, 255)",
      strokeWidth: 3.175,
      paintOrder: "markers"
    },
    id: "rect3812-0",
    width: 152.4,
    height: 234.164,
    x: 109.265,
    y: -23.523,
    ry: 10.319,
    rx: 10.319
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 4.845,
      paintOrder: "markers"
    },
    id: "rect10936",
    width: 119.063,
    height: 120.29,
    x: 125.934,
    y: -6.682
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      fillRule: "evenodd",
      strokeWidth: 10.005,
      paintOrder: "markers"
    },
    d: "M 136.645 51.847 L 235.067 51.847 L 235.067 61.297 L 219.828 62.825 L 135.846 62.825 L 136.645 51.847 Z",
    id: "path12496-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      fillRule: "evenodd",
      strokeWidth: 10.99,
      paintOrder: "markers"
    },
    d: "M 148.603 37.157 L 232.515 37.157 L 235.067 48.231 L 235.067 50.523 L 148.603 50.523 L 148.603 37.157 Z",
    id: "path12714-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      fillRule: "evenodd",
      strokeWidth: 3.628,
      paintOrder: "markers"
    },
    d: "M 146.993 37.157 L 137.662 37.157 L 136.985 50.523 L 146.993 50.523 L 146.993 37.157 Z",
    id: "path12714-4-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13543-72",
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 9.943,
      paintOrder: "markers"
    },
    d: "M 150.686 39.45 L 164.699 39.45 L 164.699 48.231 L 150.686 48.231 L 150.686 39.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13543-8-8",
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 9.943,
      paintOrder: "markers"
    },
    d: "M 139.465 39.45 L 144.621 39.45 L 144.621 48.231 L 139.465 48.231 L 139.465 39.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13543-6-5",
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 9.943,
      paintOrder: "markers"
    },
    d: "M 167.033 39.45 L 181.046 39.45 L 181.046 48.231 L 167.033 48.231 L 167.033 39.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13543-7-0",
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 9.943,
      paintOrder: "markers"
    },
    d: "M 183.38 39.45 L 197.393 39.45 L 197.393 48.231 L 183.38 48.231 L 183.38 39.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13543-9-7",
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 9.943,
      paintOrder: "markers"
    },
    d: "M 199.727 39.45 L 213.74 39.45 L 213.74 48.231 L 199.727 48.231 L 199.727 39.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13543-9-3-0",
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 9.943,
      paintOrder: "markers"
    },
    d: "M 216.074 39.45 L 230.572 39.45 L 232.646 48.231 L 216.074 48.231 L 216.074 39.45 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 32.553,
      paintOrder: "markers"
    },
    id: "path13773-7-9-2",
    cx: 151.011,
    cy: 61.355,
    rx: 7.893,
    ry: 7.893
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 0, 0)",
      fillRule: "evenodd",
      strokeWidth: 27.761,
      paintOrder: "markers"
    },
    id: "path13773-7-5",
    cx: 151.011,
    cy: 61.355,
    r: 6.731
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 10.71,
      paintOrder: "markers"
    },
    id: "path13773-74",
    cx: 151.011,
    cy: 61.355,
    rx: 2.597,
    ry: 2.597
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 32.553,
      paintOrder: "markers"
    },
    id: "path13773-7-9-8-1",
    cx: 211.331,
    cy: 61.355,
    rx: 7.893,
    ry: 7.893
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 0, 0)",
      fillRule: "evenodd",
      strokeWidth: 27.761,
      paintOrder: "markers"
    },
    id: "path13773-7-8-5",
    cx: 211.33,
    cy: 61.355,
    r: 6.731
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd",
      strokeWidth: 10.71,
      paintOrder: "markers"
    },
    id: "path13773-0-9",
    cx: 211.331,
    cy: 61.355,
    rx: 2.597,
    ry: 2.597
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9P);
export default __webpack_public_path__ + "static/media/9p.493471c6c503a6eef95d06fe253e8906.svg";
export { ForwardRef as ReactComponent };